<template>
  <div class="article">
    <section class="section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title">Article</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link class="button is-info" :to="{name: 'article.create'}">
              Create
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <b-table
        paginated
        backend-pagination
        :loading="loading"
        :data="articles ? articles.docs : []"
        :per-page="25"
        :current-page="$route.query.page || 1"
        :total="articles ? articles.total : 0"
        @page-change="onPageChange"
      >
        <template slot-scope="props">
          <b-table-column label="Thumbnail" width="160">
            <img :src="getThumbnail(props.row.ArticleAssets) || 'http://placehold.it/640x480?text=No%20Image'">
          </b-table-column>
          <b-table-column label="Content">
            <p class="field">
              {{ props.row.title }}
            </p>
            <p class="field">
              <a :href="aritlceUrl(props.row)" target="_blank">
                {{aritlceUrl(props.row)}}
              </a>
            </p>
            <p class="field">
              <span class="tags">
                <span class="tag" v-for="tag in props.row.Tags" :key="tag.id">
                  {{ tag.name }}
                </span>
              </span>
            </p>
            <p class="field">
              <span class="is-size-7 has-text-grey is-italic">
                Last modify {{ $moment(props.row.updatedAt || props.row.createdAt)
                  .format('D MMM Y HH:mm:ss') }}
              </span>
            </p>
          </b-table-column>
          <b-table-column label="#" width="250">
            <p class="field" v-if="props.row.published">
              <span class="tags has-addons">
                <span class="tag">Status</span>
                <span class="tag is-primary">Published</span>
              </span>
            </p>
            <p class="field" v-else>
              <span class="tags has-addons">
                <span class="tag">Status</span>
                <span class="tag is-danger">Unpublished</span>
              </span>
            </p>
            <p class="field">
              <span class="tags has-addons">
                <span class="tag">Content At</span>
                <span class="tag is-dark">
                  {{ $moment(props.row.contentAt).format('D MMM Y') }}
                </span>
              </span>
            </p>
            <p class="field">
              <span class="tags has-addons">
                <span class="tag">Active At</span>
                <span class="tag is-dark">
                  {{ $moment(props.row.activeAt).format('D MMM Y') }}
                </span>
              </span>
            </p>
          </b-table-column>
          <b-table-column label="Action" centered width="150">
            <div class="buttons">
              <router-link
                class="button is-warning"
                :to="{name: 'article.info', params: {id: props.row.id}}"
              >
                <b-icon icon="edit" size="is-small" />
              </router-link>
              <button class="button is-danger" @click="onDelete(props.row.id)">
                <b-icon icon="trash-alt" size="is-small" />
              </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'my-article',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('article', ['articles']),
  },
  methods: {
    ...mapActions('article', ['getArticles', 'deleteArticle']),
    fetch() {
      this.loading = true
      this.getArticles({
        page: this.$route.query.page || 1,
      }).then(() => {
        window.scrollTo(0,0)
      }).finally(() => {
        this.loading = false
      });;
    },
    onPageChange(page) {
      this.loading = true
      this.$router.push({ query: { page } });
      this.getArticles({
        page,
      }).then(() => {
        window.scrollTo(0,0)
      }).finally(() => {
        this.loading = false
      });
    },
    onDelete(id) {
      this.$swal.fire({
        title: 'Delete ?',
        type: 'warning',
        showCancelButton: true,
        preConfirm: () => this.deleteArticle(id),
      }).then(() => {
        this.fetch();
        this.$swal.fire('Deleted!');
      });
    },
    getThumbnail(assets) {
      const thumbnail = assets.find(i => i.type === 'thumbnail');

      return thumbnail ? thumbnail.url : null;
    },
    aritlceUrl(data) {
      return `${this.$websiteUrl}/articles/${data.slug || data.id}`;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
